import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { BillingDetails } from "@/models/billing/BillingDetails";
import { AppService } from "@services/app.service";
import * as CryptoJS from 'crypto-js';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-bill',
  templateUrl: './bill.component.html',
  styleUrl: './bill.component.scss'
})
export class BillComponent {
  billDetails: BillingDetails;
  private secretKey = "#EVOL-&$%$DF%SION*^%#^*F&%^DFSEYUJ";
  billId: number = 0;
  billType: string = "";

  constructor(private route: ActivatedRoute, private appService: AppService, private router: Router,
    private spinner: NgxSpinnerService, private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['billId'], params['billType']) {
        const decryptedBillId = CryptoJS.AES.decrypt(params['billId'], this.secretKey).toString(CryptoJS.enc.Utf8);
        const decryptedBillType = CryptoJS.AES.decrypt(params['billType'], this.secretKey).toString(CryptoJS.enc.Utf8);
        this.billType = decryptedBillType
        this.billId = Number(decryptedBillId);
        console.log(this.billId)

      }
    });
    this.fetchBillDetails(this.billId);
  }

  fetchBillDetails(billId: number): void {
    this.spinner.show();
    this.appService.getBillDetailById(billId)
      .subscribe(
        (response: BillingDetails) => {
          this.spinner.hide();
          this.billDetails = response;
          console.log(`billed details::`, this.billDetails);
          setTimeout(() => {
            this.printBill();
          }, 1000);
        }, (error: any) => {
          this.spinner.hide();
          console.error('save invoice details:', error);
          this.toastr.error(error.error.message);
        },);
  }

  printBill(): void {
    window.print();
    setTimeout(() => {
      this.router.navigate(['/main/shop-bill-list']);
    }, 1000);
  }

    // For amount letter format
    numberToWords(number: number): string {
      const units: string[] = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
      const teens: string[] = ["", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
      const tens: string[] = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
      function convertThreeDigits(num: number): string {
        let result = "";
        if (num >= 100) {
          result += units[Math.floor(num / 100)] + " Hundred ";
          num %= 100;
        }
        if (num >= 20) {
          result += tens[Math.floor(num / 10)] + " ";
          num %= 10;
        }
        if (num > 0) {
          if (num < 10) {
            result += units[num] + " ";
          } else {
            result += teens[num - 10] + " ";
          }
        }
        return result.trim();
      }
  
      const crores = Math.floor(number / 10000000);
      const millions = Math.floor(number % 10000000 / 100000);
      const lakhs = Math.floor(number % 100000 / 1000);
      const thousands = Math.floor(number % 1000);
      const hundreds = Math.floor(number % 100);
  
      let result = "";
  
      if (crores > 0) {
        result += convertThreeDigits(crores) + " Crore ";
      }
  
      if (millions > 0) {
        result += convertThreeDigits(millions) + " Lakh ";
      }
  
      if (lakhs > 0) {
        result += convertThreeDigits(lakhs) + " Thousand ";
      }
  
      if (thousands > 0) {
        result += convertThreeDigits(thousands) + " ";
      }
  
      if (result === "") {
        return "zero Only";
      }
  
      return result;
    }
  
  getCurrentDate(): string {
      return new Date().toLocaleDateString('en-GB'); // dd/mm/yyyy format
    }
    
getCurrentTime(): string {
      return new Date().toLocaleTimeString('en-US', { hour12: true }).replace(/:/g, ':'); // hh-mm-ss AM/PM
    }
    
}
